import {StreamLanguage, StreamParser, StringStream} from '@codemirror/stream-parser';

var keywords = /^(move|turn|var|set|get_position|get_direction|add|sub|and|or|xor|test|explore|jump|branch|call|end|set_arg|get_arg|debug|mark|unmark|get_mark|arr_set|arr_get|matr_set|matr_get)\b/;
var types = /^(int|position|direction|object)\b/;
var literals = /^(left|right|front|back|north|east|south|west|wall|path)\b/;
var comparators = /^(equal|lequal|less|gequal|greater|nequal)\b/;
var name = /^([A-Za-z][A-Za-z0-9_]*)\b/;
var number = /^(0|-?[1-9][0-9]*)\b/;

export const amazingLanguage = StreamLanguage.define({
	token(stream, state) {
		if (stream.eatSpace()) return null;
		if (stream.eat('#')){
			stream.skipToEnd();
			return 'comment';
		}
		if (stream.match(keywords)) return 'keyword';
		if (stream.match(types)) return 'typeName';
		if (stream.match(literals)) return 'literal';
		if (stream.match(comparators)) return 'operator';
		if (stream.match(name)) return 'variableName';
		if (stream.match(number)) return 'number';
		if (stream.eat(':'))
			return null;
		stream.next();
	}
});